// @flow

// Vendor
import React from 'react';

// Types
type Props = {
  thumbnail?: {
    src: String,
    alt: String
  },
  placeholderSize: {
    width: Number,
    height: Number
  },
  hoverText?: String
};

const Thumbnail = ({
  src = '',
  alt = '',
  placeholderSize,
  hoverText
}: Props) => (
  <div className="thumbnail">
    <div
      className="image-background"
      style={{
        backgroundImage: `url(${src})`
      }}
    >
      {src && <img src={src} alt={alt} className="image-background__content" />}
      <div
        style={{
          width: '100%',
          paddingBottom: `${(placeholderSize.height * 100) /
            placeholderSize.width}%`
        }}
      />
    </div>
    {hoverText && (
      <div className="thumbnail__overlay">
        <span className="thumbnail__overlay__text">
          {hoverText} <span className="fas fa-arrow-right" />
        </span>
      </div>
    )}
  </div>
);

export default Thumbnail;
